import { Box } from '@material-ui/core';

const bulletStyles = {
  borderRadius: '50%',
  minWidth: 14,
  height: 14,
};

export const MapLegend = () => {
  return (
    <Box
      style={{
        position: 'absolute',
        bottom: 35,
        left: 0,
        margin: 25,
        zIndex: 5,
        backgroundColor: 'white',
        padding: 8,
        color: 'var(--color-main-orange)',
        border: '1px solid var(--color-main-orange)',
        borderRadius: 8,
        lineHeight: 1,
        gap: 6,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Box
          style={{
            ...bulletStyles,
            backgroundColor: 'var(--color-main-orange)',
          }}
        />
        <Box>Placówka przyjmuje wszystkie dzieci.</Box>
      </Box>
      <Box style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Box
          style={{
            ...bulletStyles,
            backgroundColor: 'var(--color-blue-slider)',
          }}
        />
        <Box>Placówka przyjmuje tylko dzieci uczęszczające do niej.</Box>
      </Box>
    </Box>
  );
};
